import script from "./ApprovalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalCenter.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalCenter.vue?vue&type=style&index=0&id=3323241a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3323241a"]])

export default __exports__